import Truncator from '@/components/Truncator';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import { Accordion, Header, TableContent, ChangeText } from './styled';
import {
  Roles,
  RolesWithTitles,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { useTracking } from 'react-tracking';
import { useTranslation } from '@/hooks/useTranslation';
import { useLocale } from '@/hooks/useLocale';

interface Owner {
  name: string;
  teamTitle: string;
  boardTitle: string;
}

interface Props {
  rankSharesHeld: number;
  owner: Owner;
  holdingValue: string;
  holdingDate: string;
  sharesHeldFormat: string;
  percentOfPortfolio: number;
  percentOfSharesOutstanding: number;
  percentSharesChanged: number;
  handleClick: (index: number) => void;
  isOpen: boolean;
}

const TopShareholdersAccordionDetails = ({
  rankSharesHeld,
  owner,
  holdingDate,
  holdingValue,
  sharesHeldFormat,
  percentOfPortfolio,
  percentOfSharesOutstanding,
  percentSharesChanged,
  handleClick,
  isOpen,
}: Props) => {
  const tracking = useTracking();
  const t = useTranslation();
  const locale = useLocale();
  return (
    <>
      <Accordion>
        <Header
          noWrap={true}
          onClick={() => {
            handleClick(rankSharesHeld);
            tracking.trackEvent({
              modifier: 'shareholder',
              action: 'click',
              properties: {
                index: rankSharesHeld,
                ownershipPercentage: percentOfSharesOutstanding,
                name: owner.name,
                isManagementOrBoard:
                  owner.boardTitle !== '' || owner.teamTitle !== '',
              },
            });
          }}
        >
          <div>
            <span>{owner.name}</span>
            <Roles boardTitle={owner.boardTitle} teamTitle={owner.teamTitle} />
          </div>
          <div>
            {(percentOfSharesOutstanding * 0.01).toLocaleString(locale, {
              style: 'percent',
              minimumFractionDigits: 1,
              maximumFractionDigits: 2,
              maximumSignificantDigits: 3,
            })}
          </div>
          {!isOpen ? <ChevronRightSmallSolid /> : <ChevronDownSmallSolid />}
        </Header>
        <div>
          <Truncator open={isOpen} minHeight={0} animationDuration={0.4}>
            <TableContent>
              <tbody>
                {(owner.boardTitle !== '' || owner.teamTitle !== '') && (
                  <tr>
                    <td>
                      {t(
                        'page.companyReport.ownership.topShareholder.accordionRow1'
                      )}
                    </td>
                    <td>
                      <RolesWithTitles
                        boardTitle={owner.boardTitle}
                        teamTitle={owner.teamTitle}
                      />
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    {t(
                      'page.companyReport.ownership.topShareholder.cellHeading3'
                    )}
                  </td>
                  <td>{sharesHeldFormat}</td>
                </tr>
                <tr>
                  <td>
                    {t(
                      'page.companyReport.ownership.topShareholder.accordionRow3'
                    )}
                  </td>
                  <td>{holdingValue}</td>
                </tr>
                <tr>
                  <td>
                    {t(
                      'page.companyReport.ownership.topShareholder.cellHeading5'
                    )}
                  </td>
                  <td>
                    <ChangeText percentSharesChanged={percentSharesChanged}>
                      {(percentSharesChanged * 0.01).toLocaleString(locale, {
                        style: 'percent',
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 2,
                        maximumSignificantDigits: 3,
                      })}
                    </ChangeText>
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      'page.companyReport.ownership.topShareholder.cellHeading6'
                    )}
                  </td>
                  <td>
                    {(percentOfPortfolio * 0.01).toLocaleString(locale, {
                      style: 'percent',
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 2,
                      maximumSignificantDigits: 3,
                    })}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      'page.companyReport.ownership.topShareholder.accordionRow6'
                    )}
                  </td>
                  <td>{holdingDate}</td>
                </tr>
              </tbody>
            </TableContent>
          </Truncator>
        </div>
      </Accordion>
    </>
  );
};
export default TopShareholdersAccordionDetails;
